var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"h5"},[_vm._v(" "+_vm._s(_vm.$t(`rewards.landing.available_rewards.dollars`))+" "),_c('span',{staticClass:"text-green-500"},[_vm._v(" "+_vm._s(_vm.availableRewardsCount)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }